module.exports = __webpack_public_path__ + "img/terrace.f269d7bd.png";